import React from 'react';
import AdminPage from '../components/admin/AdminPage';
import { useAuth } from '../context/AuthContext';
import { useShellUiActions } from '../context/ShellUiContext';

// BAR-40 S3: /admin route. Replaces the mainView==='admin' ternary branch
// (verbatim), including the client-side is_admin gate + permission-denied panel
// (preserves today's behavior; backend is_admin enforcement is out of scope).
export default function AdminRoute() {
  const { userData, authToken } = useAuth();
  const { navigateToView } = useShellUiActions();

  if (!userData?.is_admin) {
    return (
      <div className="h-full flex items-center justify-center text-fg-tertiary">
        <div className="text-center">
          <h2 className="text-xl font-semibold mb-2">Admin access required</h2>
          <p>You do not have permission to view this page.</p>
          <button
            onClick={() => navigateToView('landing')}
            className="mt-4 text-sm underline text-accent"
          >
            Back to home
          </button>
        </div>
      </div>
    );
  }

  // authToken is guaranteed non-null here: this route is under RequireAuth and
  // we only reach AdminPage when userData?.is_admin is truthy (i.e. logged in).
  return (
    <AdminPage authToken={authToken!} currentUserUid={userData?.id || userData?.uid || undefined} />
  );
}
